import axios from "axios";
const baseUrl = process.env.REACT_APP_BASE_URL;

export const login = async (email, password) => {
    try {
        const response = await axios.post(`${baseUrl}users/login`, { email, password });
        return response.data;
    } catch (error) {
        throw error;
    }
};

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const handleUnauthorizedResponse = (error) => {
    localStorage.removeItem("token");
    window.location.href = "/login";
    throw error;
};

// transaction
export const addTransaction = async (body) => {
    try {
        // const response = await axios.post(`${baseUrl}transaction/add`, body);
        const formData = new FormData();

        for (const key in body) {
            if (body[key] || body[key] === "") {
                if (key === "attachment" && body[key] instanceof File) {
                    formData.append(key, body[key]);
                } else {
                    formData.append(key, body[key]);
                }
            }
        }
        const response = await axios.post(`${baseUrl}transaction/add`, formData, {
            headers: {
                "Content-Type": "multipart/form-data", // Ensure content type is set to form-data
            },
        });
        return response.data;
    } catch (error) {
        console.log("error: ", error);
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const updateTransaction = async (id, body) => {
    console.log("body: ", body);
    try {
        const formData = new FormData();

        // Loop through the object and append each key-value pair to FormData
        for (const key in body) {
            if (body[key] || body[key] === "") {
                if (key === "attachment" && body[key] instanceof File) {
                    // Append the file only if it's an instance of File
                    formData.append(key, body[key]);
                } else {
                    // For other fields, append as a regular form field
                    formData.append(key, body[key]);
                }
            }
        }
        const response = await axios.put(`${baseUrl}transaction/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data", // Ensure content type is set to form-data
            },
        });
        // const response = await axios.put(`${baseUrl}transaction/${id}`, body);
        return response.data;
    } catch (error) {
        console.log("error: ", error);
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getAllOwners = async (limit, offset, search) => {
    try {
        const response = await axios.get(`${baseUrl}owners`, {
            params: {
                limit,
                offset,
                search,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const addOwner = async (body) => {
    try {
        // const response = await axios.post(`${baseUrl}owners/add`, body);
        // return response.data;
        const formData = new FormData();

        for (const key in body) {
            if (key !== "docs") {
                formData.append(key, body[key]);
            }
        }

        body.docs.forEach((document, index) => {
            formData.append(`docs[${index}][name]`, document.name);
            formData.append(`docs[${index}][file]`, document.file);
        });

        const response = await axios.post(`${baseUrl}owners/add`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        console.log("error: ", error);
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const updateOwner = async (id, body) => {
    let { name, mobile, address, arabicName } = body;
    try {
        // const response = await axios.put(`${baseUrl}owners/update/${id}`, {
        //     name,
        //     arabicName,
        //     mobile,
        //     address,
        // });
        // return response.data;
        const formData = new FormData();
        for (const key in body) {
            if (key !== "docs") {
                formData.append(key, body[key]);
            }
        }

        body.docs.forEach((document, index) => {
            formData.append(`docs[${index}][name]`, document.name);
            formData.append(`docs[${index}][file]`, document.file);
        });
        const response = await axios.put(`${baseUrl}owners/update/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const deleteOwner = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}owners/delete/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getOwnerDoc = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}owners/docs/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deleteOwnerDoc = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}owners/delete-doc/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// Property
export const getAllProperties = async (limit, offset, search, isSold) => {
    try {
        const response = await axios.get(`${baseUrl}properties`, {
            params: {
                limit,
                offset,
                search,
                isSold,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const addProperty = async (body) => {
    try {
        const formData = new FormData();

        for (const key in body) {
            if (key !== "docs") {
                formData.append(key, body[key]);
            }
        }

        body.docs.forEach((document, index) => {
            formData.append(`docs[${index}][name]`, document.name);
            formData.append(`docs[${index}][file]`, document.file);
        });

        const response = await axios.post(`${baseUrl}properties/add`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const updateProperty = async (id, body) => {
    try {
        const formData = new FormData();
        for (const key in body) {
            if (key !== "docs") {
                formData.append(key, body[key]);
            }
        }

        body.docs.forEach((document, index) => {
            formData.append(`docs[${index}][name]`, document.name);
            formData.append(`docs[${index}][file]`, document.file);
        });
        const response = await axios.put(`${baseUrl}properties/update/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const deleteProperty = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}properties/delete/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const getPropertyDoc = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}properties/docs/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deletePropertyDoc = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}properties/delete-doc/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// flats
export const getAllUnits = async (limit, offset, search, property) => {
    try {
        const response = await axios.get(`${baseUrl}flats`, {
            params: {
                limit,
                offset,
                search,
                property,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const getVacantUnits = async (limit, offset, search, property, unitId) => {
    try {
        const response = await axios.get(`${baseUrl}flats/vacant-unit`, {
            params: {
                limit,
                offset,
                search,
                property,
                unitId,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const addFlats = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}flats`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const updateFlat = async (id, body) => {
    try {
        const response = await axios.put(`${baseUrl}flats/${id}`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const deleteFlat = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}flats/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// Expense type
export const getAllExpenseType = async (limit, offset, search) => {
    try {
        const response = await axios.get(`${baseUrl}expense-types`, {
            params: {
                limit,
                offset,
                search,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const addExpenseType = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}expense-types`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const updateExpenseType = async (id, body) => {
    let { name } = body;
    try {
        const response = await axios.put(`${baseUrl}expense-types/${id}`, {
            name,
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const deleteExpenseType = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}expense-types/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// Contract registration
export const getAllContract = async (limit, offset, search, property) => {
    try {
        const response = await axios.get(`${baseUrl}contract-registration`, {
            params: {
                limit,
                offset,
                search,
                property,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getSingleContract = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}contract-registration/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const addContract = async (body) => {
    try {
        const formData = new FormData();

        for (const key in body) {
            if (key !== "docs" && key !== "pdc") {
                // Exclude "pdc" field
                formData.append(key, body[key]);
            }
        }

        if (body.pdc && Array.isArray(body.pdc)) {
            body.pdc.forEach((pdcItem, index) => {
                for (const key in pdcItem) {
                    formData.append(`pdc[${index}][${key}]`, pdcItem[key]);
                }
            });
        }

        body.docs.forEach((document, index) => {
            formData.append(`docs[${index}][name]`, document.name);
            formData.append(`docs[${index}][file]`, document.file);
        });

        const response = await axios.post(`${baseUrl}contract-registration`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const updateContract = async (id, body) => {
    try {
        // const formData = new FormData();
        // for (const key in body) {
        //     if (key !== "docs") {
        //         formData.append(key, body[key]);
        //     }
        // }

        // body.docs.forEach((document, index) => {
        //     formData.append(`docs[${index}][name]`, document.name);
        //     formData.append(`docs[${index}][file]`, document.file);
        // });

        const formData = new FormData();

        for (const key in body) {
            if (key !== "docs" && key !== "pdc") {
                // Exclude "pdc" field
                formData.append(key, body[key]);
            }
        }

        if (body.pdc && Array.isArray(body.pdc)) {
            body.pdc.forEach((pdcItem, index) => {
                for (const key in pdcItem) {
                    formData.append(`pdc[${index}][${key}]`, pdcItem[key]);
                }
            });
        }

        body?.docs?.forEach((document, index) => {
            formData.append(`docs[${index}][name]`, document.name);
            formData.append(`docs[${index}][file]`, document.file);
        });
        const response = await axios.put(`${baseUrl}contract-registration/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const deleteContract = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}contract-registration/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getContractDoc = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}contract-registration/docs/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deleteContractDoc = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}contract-registration/delete-doc/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const getContractPdc = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}contract-registration/pdc/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const getReceiptPdc = async (id, type) => {
    try {
        const response = await axios.get(`${baseUrl}contract-registration/receipt-pdc/${id}`, {
            params: {
                type,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deleteContractPdc = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}contract-registration/delete-pdc/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// get single contract by property and unit id
export const getContractByProperty = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}contract-registration/by-property`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// tenants
export const getAllTenants = async (limit, offset, search) => {
    try {
        const response = await axios.get(`${baseUrl}tenants`, {
            params: {
                limit,
                offset,
                search,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const addTenants = async (body) => {
    try {
        const formData = new FormData();

        for (const key in body) {
            if (key !== "docs") {
                formData.append(key, body[key]);
            }
        }

        body.docs.forEach((document, index) => {
            formData.append(`docs[${index}][name]`, document.name);
            formData.append(`docs[${index}][file]`, document.file);
        });

        const response = await axios.post(`${baseUrl}tenants`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        // const response = await axios.post(`${baseUrl}tenants`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const updateTenants = async (id, body) => {
    try {
        const formData = new FormData();
        for (const key in body) {
            if (key !== "docs") {
                formData.append(key, body[key]);
            }
        }

        body.docs.forEach((document, index) => {
            formData.append(`docs[${index}][name]`, document.name);
            formData.append(`docs[${index}][file]`, document.file);
        });
        const response = await axios.put(`${baseUrl}tenants/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        // const response = await axios.put(`${baseUrl}tenants/${id}`, {
        //     name,
        //     nationality,
        //     mobileNumber,
        //     emiratesId,
        // });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const deleteTenants = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}tenants/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getTenantDoc = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}tenants/docs/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deleteTenantDoc = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}tenants/delete-doc/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// dashboard
export const getAllDashboardData = async (ownerId) => {
    try {
        const response = await axios.get(`${baseUrl}dashboard`, {
            params: {
                ownerId,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// back
export const getAllBanks = async (limit, offset, search) => {
    try {
        const response = await axios.get(`${baseUrl}banks`, {
            params: {
                limit,
                offset,
                search,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// Transaction
export const getAllTransaction = async (limit, offset, from, to, type, propertyId, unitId, closedContract) => {
    try {
        const response = await axios.get(`${baseUrl}transaction`, {
            params: {
                limit,
                offset,
                from,
                to,
                type,
                propertyId,
                unitId,
                closedContract,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// master report v2 (fixed GROUP BY cr.id)
export const getMasterReportV2 = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}properties/master-report-v2`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const getDetailsReportV2 = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}properties/details-report-v2`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const getUnitReportV2 = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}flats/unit-report-v2`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
// master report
export const getMasterReport = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}properties/master-report`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
// units report
export const getUnitReport = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}flats/unit-report`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
// get single property
export const getDetailsReport = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}properties/details-report`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
// details report
export const getSingleProperty = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}properties/single-details`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const setPropertyAsDefault = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}users/set-as-default`, body);

        return response.data;
    } catch (error) {
        console.log("error: ", error);
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const getSearchReport = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}contract-registration/search/${id}`);

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deleteTransaction = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}transaction/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// get owner wise report
export const getOwnerWiseReport = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}owners/owner-wise-report`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// get owner and month wise report
export const getOwnerAndMonthWiseReport = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}owners/owner-month-wise-report`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// get single contract by property and unit id
export const getContractByUnit = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}contract-registration/by-unit`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getRentDueReport = async (propertyId) => {
    try {
        const response = await axios.get(`${baseUrl}contract-registration/rent-due-report`, {
            params: {
                propertyId,
            },
        });

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const getPdcDueReport = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}contract-registration/pdc-due-report`, body);

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const addRole = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}roles/add`, body);
        return response.data;
    } catch (error) {
        console.log("error: ", error);
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const updateRole = async (id, body) => {
    let { name, permission } = body;
    try {
        const response = await axios.put(`${baseUrl}roles/update/${id}`, {
            name,
            permission,
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getAllRoles = async (limit, offset, search) => {
    try {
        const response = await axios.get(`${baseUrl}roles`, {
            params: {
                limit,
                offset,
                search,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const deleteRoles = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}roles/delete/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const addUser = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}users/add`, body);
        return response.data;
    } catch (error) {
        console.log("error: ", error);
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const updateUser = async (id, body) => {
    let { name, email, password, roleId, isAdmin, propertyIds } = body;
    try {
        const response = await axios.put(`${baseUrl}users/update/${id}`, {
            name,
            email,
            password,
            roleId,
            isAdmin,
            propertyIds,
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getAllUsers = async (limit, offset, search) => {
    try {
        const response = await axios.get(`${baseUrl}users`, {
            params: {
                limit,
                offset,
                search,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deleteUser = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}users/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// vouchers
export const addVoucher = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}vouchers/add`, body);
        return response.data;
    } catch (error) {
        console.log("error: ", error);
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getAllVoucherReceipts = async (limit, offset, search) => {
    try {
        const response = await axios.get(`${baseUrl}vouchers`, {
            params: {
                limit,
                offset,
                search,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const handleVoucherPost = async (id) => {
    try {
        const response = await axios.post(`${baseUrl}vouchers/handle-post/${id}  `, {});
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deleteVoucher = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}vouchers/delete/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const getAllRentDispute = async (limit, offset, search) => {
    try {
        const response = await axios.get(`${baseUrl}rent-dispute`, {
            params: {
                limit,
                offset,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getSingleVoucherDetails = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}vouchers/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const updateRentDispute = async (id, body) => {
    // let {
    //     contractId,
    //     propertyId,
    //     unitId,
    //     isCaseRegistered,
    //     rentAdjustFromDeposit,
    //     rentBalance,
    //     deposit,
    //     remarks,
    //     closed,
    // } = body;
    try {
        const response = await axios.put(`${baseUrl}rent-dispute/update/${id}`, {
            ...body,
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getPropertyExpenseReport = async (body) => {
    try {
        const response = await axios.post(
            `${baseUrl}transaction/property-wise-expense-report`,
            body
        );

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getOwnerExpenseReport = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}transaction/owner-wise-expense-report`, body);

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const unitVacantReport = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}flats/unit-vacant-report`, body);

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const upcomingContractReport = async (body) => {
    try {
        const response = await axios.post(
            `${baseUrl}contract-registration/upcoming-contract-report`,
            body
        );

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const commonExpenseReport = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}transaction/common-expense-report`, body);

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const statementRentalIncomeReport = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}transaction/rental-income-report`, body);

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const commonExpenseList = async (limit, offset, from, to) => {
    try {
        const response = await axios.get(`${baseUrl}transaction/common-expense-list`, {
            params: {
                limit,
                offset,
                from,
                to,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const changePassword = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}users/change-password`, body);

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// transaction
export const addEmployee = async (body) => {
    try {
        const formData = new FormData();

        for (const key in body) {
            if (key !== "docs") {
                formData.append(key, body[key]);
            }
        }

        body.docs.forEach((document, index) => {
            formData.append(`docs[${index}][name]`, document.name);
            formData.append(`docs[${index}][file]`, document.file);
        });
        const response = await axios.post(`${baseUrl}employees`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        console.log("error: ", error);
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const updateEmployee = async (id, body) => {
    try {
        const formData = new FormData();
        for (const key in body) {
            if (key !== "docs") {
                formData.append(key, body[key]);
            }
        }

        body.docs.forEach((document, index) => {
            formData.append(`docs[${index}][name]`, document.name);
            formData.append(`docs[${index}][file]`, document.file);
        });
        const response = await axios.put(`${baseUrl}employees/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        console.log("error: ", error);
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const terminateEmployeeApi = async (id, body) => {
    try {
        const response = await axios.put(`${baseUrl}employees/terminate/${id}`, body);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getAllEmployees = async (limit, offset, search, showInactive) => {
    try {
        const response = await axios.get(`${baseUrl}employees`, {
            params: {
                limit,
                offset,
                search,
                showInactive,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deleteEmployee = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}employees/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getEmployeeDoc = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}employees/docs/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deleteEmployeeDoc = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}employees/delete-doc/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// payment  vouchers
export const addPaymentVoucher = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}payment-vouchers/add`, body);
        return response.data;
    } catch (error) {
        console.log("error: ", error);
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getAllPaymentVoucher = async (limit, offset, search) => {
    try {
        const response = await axios.get(`${baseUrl}payment-vouchers`, {
            params: {
                limit,
                offset,
                search,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deletePaymentVoucher = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}payment-vouchers/delete/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getSinglePaymentVoucher = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}payment-vouchers/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

// snap short
export const addSnapshot = async (body) => {
    try {
        const formData = new FormData();

        for (const key in body) {
            if (body[key] || body[key] === "") {
                if (key === "fileUrl" && body[key] instanceof File) {
                    formData.append(key, body[key]);
                } else {
                    formData.append(key, body[key]);
                }
            }
        }
        const response = await axios.post(`${baseUrl}snapshot`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        console.log("error: ", error);
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const getAllSnapshot = async (limit, offset) => {
    try {
        const response = await axios.get(`${baseUrl}snapshot`, {
            params: {
                limit,
                offset,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};

export const deleteSnapshot = async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}snapshot/${id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
export const depositRegisterReport = async (body) => {
    try {
        const response = await axios.post(`${baseUrl}transaction/deposit-register-report`, body);

        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            handleUnauthorizedResponse(error);
        } else {
            throw error;
        }
    }
};
